<template>
  <div class="ui-modal-card">
    <slot />
  </div>
</template>
